module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.Data) ? _c('div', {
    staticClass: "limits-block-wrapper"
  }, [_c('div', {
    staticClass: "progress-layer"
  }, [_vm._l((_vm.Data), function(type, i) {
    return [_c('div', {
      key: 'pt-' + i,
      staticClass: "progress-text"
    }, [_vm._v(_vm._s(_vm._f("ftc")(type.name)) + ": "), _c('span', {
      staticClass: "pull-right"
    }, [_vm._v(_vm._s(type.data['ordered'])), (type.data['limit_max_count'] < 100000) ? _c('span', [_vm._v(" " + _vm._s(_vm._f("ftc")('main/out_of')) + " " + _vm._s(type.data['limit_max_count']))]) : _vm._e()])]), _vm._v(" "), _c('div', {
      key: 'pw-' + i,
      staticClass: "progress progress-striped progress-wrapper"
    }, [_c('div', {
      staticClass: "progress-bar",
      class: _vm.percents(i) < 99.99 ? 'progress-bar-info' : 'progress-bar-danger',
      style: ('width: ' + _vm.percents(i) + '%')
    })]), _vm._v(" "), _c('div', {
      key: 'ptu-' + i,
      staticClass: "progress-underline-text"
    }, [(type.data['limit_child_count']) ? _c('span', [_vm._v(_vm._s(_vm._f("ftc")('account/limit_not_greater')) + " " + _vm._s(type.data['limit_child_count']) + " " + _vm._s(_vm._f("ftc")('account/limit_in_service')))]) : _vm._e()])]
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "clearfix"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be531752"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/limits.vue
// module id = 716
// module chunks = 0